import { z } from 'zod';

const objectId = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid id');
const dateLike = z.string().or(z.date());

export const DISPOSAL_RUN_STATUSES = ['planned', 'in_progress', 'completed', 'cancelled'];
export const DISPOSAL_BASES = [
    'sure_doldu', 'dsr_silme', 'amac_ortadan_kalkti', 'hukuki_dayanak_kalkti', 'diger',
];
export const DISPOSAL_RECORD_STATUSES = ['planned', 'completed', 'cancelled'];

export const DisposalRunSchema = z.object({
    id: z.string().optional(),
    code: z.string().optional(),
    title: z.string().min(1),
    description: z.string().optional(),
    periodStart: dateLike.optional(),
    periodEnd: dateLike.optional(),
    scheduledDate: dateLike.optional(),
    status: z.enum(DISPOSAL_RUN_STATUSES).optional(),
    customFields: z.record(z.any()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateDisposalRunSchema = DisposalRunSchema.omit({ id: true, createdAt: true, updatedAt: true, status: true });
export const UpdateDisposalRunSchema = DisposalRunSchema.omit({ id: true, createdAt: true, updatedAt: true }).partial();

export const DisposalRecordSchema = z.object({
    id: z.string().optional(),
    runId: objectId.nullable().optional(),
    inventoryItemId: objectId.nullable().optional(),
    processingActivityId: objectId.nullable().optional(),
    dataCategoryId: objectId.nullable().optional(),
    dataDescription: z.string().min(1),
    basis: z.enum(DISPOSAL_BASES),
    sourceDsrId: objectId.nullable().optional(),
    methodId: objectId.nullable().optional(),
    methodNote: z.string().optional(),
    performedBy: objectId.nullable().optional(),
    approvedBy: objectId.nullable().optional(),
    disposedAt: dateLike.optional(),
    evidence: z.string().optional(),
    status: z.enum(DISPOSAL_RECORD_STATUSES).optional(),
    customFields: z.record(z.any()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateDisposalRecordSchema = DisposalRecordSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateDisposalRecordSchema = DisposalRecordSchema.omit({ id: true, createdAt: true, updatedAt: true }).partial();

/** POST /:id/complete — method + approver may come from body or existing tutanak rows. */
export const CompleteDisposalRunSchema = z.object({
    methodId: objectId.optional(),
    approvedBy: objectId.optional(),
});
